import { combineReducers } from "redux";
import createApplication from "./createApplication.reducer"
import fetchAllCourse from "./fetchAllCourses.reducer"
import fetchFurtherDetails from "./fetchFurtherDetails.reducer"
import fetchPersonalDetails from "./fetchPersonalDetails.reducer"
import fetchQualification from "./fetchQualification.reducer"
import fetchStudentCourse from "./fetchStudentCourse.reducer"
import submitApplication from "./submitApplication.reducer"
import updateCourse from "./updateCourse.reducer"
import updateEvidence from "./updateEvidence.reducer"
import updateFurtherDetails from "./updateFurtherDetails.reducer"
import updatePersonalDetails from "./updatePersonalDetails.reducer"
import updateQualification from "./updateQualification.reducer"
import studenFiles from './getSharepointfiles.reducer'
import deleteCourse from "./deleteCourse.reducer"
import deleteQualification from "./deleteQualification.reducer"
import getStudentId from "./getStudentId.reducer";
import fetchApplication from "./fetchApplication.reducer"
import submitConsent from "./submitConsent.reducer"

const studentReducers = combineReducers({
    createApplication,
    fetchAllCourse,
    fetchFurtherDetails,
    fetchPersonalDetails,
    fetchQualification,
    fetchStudentCourse,
    submitApplication,
    updateCourse,
    updateEvidence,
    updateFurtherDetails,
    updatePersonalDetails,
    updateQualification,
    studenFiles,
    deleteCourse,
    deleteQualification,
    getStudentId,
    fetchApplication,
    submitConsent
});

export default studentReducers;
